import React from "react";
import { StoryElement } from "@quintype/components";
import { object, func } from "prop-types";

import Close from ".././../atoms/icons/close";

import "./light-box.m.css";

const LightBox = props => (
  <div styleName="wrapper">
    <div styleName="lightbox" className="lightbox">
      <figure>
        <StoryElement element={props.element} externalLink={true} />
      </figure>
      <button onClick={props.closePopup} styleName="icon-close">
        <Close color="#1c1c1c" />
      </button>
    </div>
  </div>
);

LightBox.propTypes = {
  element: object,
  closePopup: func
};

export default LightBox;
